
import { useState, useRef } from 'react';
import { FastingProtocol } from '@/types/fasting';

interface TimerStateProps {
  initialIsActive?: boolean;
  initialIsPaused?: boolean;
  initialTimeElapsed?: number;
  initialStartTime?: number | null;
  initialPausedTime?: number | null;
  initialTotalPauseDuration?: number;
}

export const useTimerState = ({
  initialIsActive = false,
  initialIsPaused = false,
  initialTimeElapsed = 0,
  initialStartTime = null,
  initialPausedTime = null,
  initialTotalPauseDuration = 0,
}: TimerStateProps) => {
  const [isActive, setIsActive] = useState(initialIsActive);
  const [isPaused, setIsPaused] = useState(initialIsPaused);
  const [timeElapsed, setTimeElapsed] = useState(initialTimeElapsed);
  const [startTime, setStartTime] = useState<number | null>(initialStartTime);
  const [pausedTime, setPausedTime] = useState<number | null>(initialPausedTime);
  const [totalPauseDuration, setTotalPauseDuration] = useState<number>(initialTotalPauseDuration);
  
  const intervalRef = useRef<NodeJS.Timeout | null>(null);
  const initRef = useRef(false);

  return {
    isActive,
    setIsActive,
    isPaused,
    setIsPaused,
    timeElapsed,
    setTimeElapsed,
    startTime,
    setStartTime,
    pausedTime,
    setPausedTime,
    totalPauseDuration,
    setTotalPauseDuration,
    intervalRef,
    initRef
  };
};
